<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-05-18 11:09:08
 * @LastEditors: sjq
 * @LastEditTime: 2023-05-22 13:41:18
 -->
<template>
  <div class="infinite-card-deduction">
    <app-header title="无限卡优惠查询"></app-header>
    <div class="pd16">
      <div id="userDetail">
        <div class="user-detail" v-if="detail">
          <img class="bg-img" src="../../../pluginPage/images/bg.png" alt="" />
          <div class="user">
            <div class="user-avtar">
              <img :src="detail.userInfo.avtarUrl" alt="" />
            </div>
            <div class="user-name">
              <div class="name">{{ detail.userInfo.nickName }}</div>
              <div class="id">{{ detail.userInfo.userId }}</div>
            </div>
            <div class="date">
              {{ date }}
            </div>
          </div>
          <div class="price-detail">
            <div class="label">
              <img src="../../../pluginPage/images/vip.png" alt="" />
              无限卡优惠价格
            </div>
            <div class="price">
              <b>¥</b>
              {{ detail.goodsPrice }}
            </div>
          </div>
          <div class="deduction-info">
            <div class="title">升级无限卡 优惠价格</div>
            <div class="deduction-content content">
              <div class="list">
                <div class="label">历史课程消费抵扣</div>
                <div class="value">- ¥{{ detail.orderDiscount }}</div>
              </div>
              <div class="hline" v-if="detail.couponInfo || detail.activityDiscount !== null"></div>
              <div class="list" v-if="detail.couponInfo">
                <div class="label">预付订金99元立减</div>
                <div class="value" :class="{ red: detail.couponInfo && detail.couponInfo.couponId ? false : isRed }">
                  - ¥{{ detail.couponInfo ? detail.couponInfo.couponDiscount : 699 }}
                  <div class="buy" @click="buyCoupon" v-if="!detail.couponInfo.couponId">点击购买</div>
                </div>
              </div>
              <div class="list" v-if="detail.activityDiscount !== null">
                <div class="label">首日报名(仅限5月28日)</div>
                <div class="value">- ¥{{ detail.activityDiscount }}</div>
              </div>
              <div class="list">
                <div class="label">实付金额</div>
                <div class="value red">
                  ¥
                  <span style="font-size: 20px">
                    {{ detail.orderAmount }}
                  </span>
                </div>
              </div>
            </div>
            <div class="pay-info">
              <div class="title">支付方式</div>
              <div class="pay-content">
                <div class="list">
                  <div class="name">全款</div>
                  <div class="detail">¥{{ detail.orderAmount }}</div>
                </div>
                <div class="list" v-for="item in detail.installList" :key="item.id">
                  <div class="name">首付{{ item.downPayments }}（免息分期）</div>
                  <div class="detail">分{{ item.installmentNum }}期，每期还¥{{ item.installmentAmount }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img v-if="url" :src="url" id="image-element" style="width: 100%" alt="" :style="{ 'border-radius': '12px' }" />
    </div>
    <div class="history-content content" v-if="detail && url">
      <div class="list">
        <div class="label">历史消费总计</div>
        <div class="value">¥{{ detail.orderDiscount }}</div>
      </div>
      <div class="list" v-for="item in detail.discountList" :key="item.orderSn">
        <div class="label">{{ item.goodsName }}</div>
        <div class="value">¥{{ item.realPayAmount }}</div>
      </div>
    </div>
    <div class="error-box" v-else-if="!!errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
import { Button, Field, Toast } from 'vant'
import { appUserForeverInfo } from '@/api/modules/pluginPage/infiniteCardDeductionInfo'
import html2canvas from 'html2canvas'
import Body from '@/mixins/body'
let action = 'infinite'
import { appUser } from '@/utils'
import { toLoginView } from '@/utils/init/env-init'

export default {
  components: { vanButton: Button, vanField: Field },
  data() {
    return {
      userId: '',
      detail: null,
      date: '',
      url: '',
      // user: '',
      errorMessage: '',
      isTestEnv: '',
      isMobile: false,
      isRed: false,
      code: '',
      appUser
    }
  },
  mixins: [Body],

  computed: {},
  watch: {},
  created() {
    this.isTestEnv =
      process.env.NODE_ENV !== 'production' ||
      location.href.indexOf('ylyk-test.com') > 0 ||
      location.href.indexOf('ylyk.com/test/') > 0
    // 判断是否为移动设备
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  },
  mounted() {
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getDetail()
  },
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        console.log('ppppppppp')
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      this.getDetail()
    },
    getDetail() {
      let data = {
        goodsId: this.isTestEnv ? 50324 : 111004,
        num: 1
        // userId: 5402862
      }
      appUserForeverInfo(data)
        .then(res => {
          console.log(res)
          this.date = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
          this.detail = res
          this.userId = res.userInfo.userId
          let end1Time = new Date(this.detail.activityEndTime) * 1
          let nowTime = new Date() * 1
          this.isRed = true
          this.detail.activityDiscount = nowTime > end1Time ? null : this.detail.activityDiscount
          this.detail.installList = this.detail.installList.filter(item => item.downPayments < this.detail.orderAmount)
          // this.$nextTick(() => {
          //   this.createImage()
          // })
        })
        .catch(error => {
          console.log(error)
          this.detail = null
          this.url = null
          this.errorMessage = error.message
          Toast({
            message: error.message,
            duration: 1000 // 持续展示 toast
          })
        })
    },
    buyCoupon() {
      location.href = 'https://s.ylyk.com/s/U7FrEj'
    }
  }
}
</script>
<style>
.van-field__control {
  -webkit-user-select: auto !important;
}
</style>
<style lang="scss" scoped>
.infinite-card-deduction {
  background: #f0f0f0;
  font-size: 14px;
  min-height: 100%;
  max-width: 750px;
  margin: 0 auto;
}
.pd16 {
  // padding: 16px 16px 0 16px;
}
.search-box {
  display: flex;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  .btn {
    width: 80px;
  }
}
.look-status {
  margin-bottom: 18px;
  .tab {
    color: #1890ff;
  }
}
#userDetail {
}
.user-detail {
  border-radius: 12px;
  padding: 24px;
  background: url('../../../pluginPage/images/bg.png') no-repeat #fff;
  background-size: 100% auto;
  background: #fff;
  // position: absolute;
  // top: -10000px;
  position: relative;
  overflow: hidden;
  .bg-img {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  div {
    position: relative;
  }
  .user {
    display: flex;
    .user-avtar {
      width: 36px;
      height: 36px;
      margin-right: 8px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .user-name {
      flex: 1;
      color: #ffffff;
      .name {
        font-size: 15px;
        line-height: 21px;
      }
      .id {
        font-size: 12px;
        line-height: 17px;
        opacity: 0.5;
      }
    }
    .date {
      font-size: 12px;
      line-height: 17px;
      color: #ffffff;
      opacity: 0.5;
    }
  }
  .deduction-content {
    background: #ffffff;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 24px;
    .list {
      .label {
        color: #000;
      }
      .value {
        text-align: right;
        .buy {
          color: #00b259 !important;
        }
      }
    }
    .hline {
      border-bottom: 1px solid rgba(235, 235, 235, 1);
      margin-bottom: 16px;
    }
    .list:last-child {
      border-top: 1px solid rgba(235, 235, 235, 1);
      padding-top: 16px;
    }
  }
  .pay-info {
    margin-top: 32px;
  }
  .pay-content {
    background: #ffffff;
    border-radius: 12px;
    padding: 8px 24px;
    border: 1px solid rgba(235, 235, 235, 1);
    .list {
      padding: 16px 0;
      border-bottom: 1px solid rgba(235, 235, 235, 1);
      .name {
        margin-bottom: 8px;
        font-weight: 500;
      }
      .detail {
        font-size: 12px;
      }
      &:last-child {
        border: none;
      }
    }
  }
  .price-detail {
    color: #ffda98;
    display: flex;
    justify-content: space-between;
    padding: 40px 24px;
    margin: 18px 0 40px 0;
    font-weight: 500;
    align-items: center;
    img {
      width: 24px;
      height: 21px;
    }
    .price {
      font-size: 32px;
      position: relative;
      b {
        position: absolute;
        font-size: 14px;
        top: -4px;
        left: -12px;
      }
    }
  }
}
.title {
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #415399;
  text-align: center;
  margin-bottom: 16px;
  &::before,
  &::after {
    content: '';
    display: inline-block;
    width: 40px;
    height: 2px;
    background: linear-gradient(90deg, rgba(0, 102, 102, 0) 1.25%, #415399 103.75%);
    margin-bottom: 5px;
    margin-right: 10px;
  }
  &::after {
    background: linear-gradient(90deg, #415399 1.25%, rgba(0, 102, 102, 0) 103.75%);
    margin-left: 10px;
  }
}

.content {
  .list {
    display: flex;
    line-height: 21px;
    margin-bottom: 16px;
    justify-content: space-between;
    .label {
      color: #999999;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .red {
    color: #ff0000 !important;
    div {
      color: #ff0000 !important;
    }
  }
}

.save-btn-tip {
  color: rgba(0, 0, 0, 0.5);
  margin: 8px 0;
  text-align: center;
  .btn {
    width: 100%;
    border-radius: 8px;
  }
}
.history-content {
  background: #fff;
  padding: 24px;
  .value {
    color: #999;
  }

  .list:first-child {
    border-bottom: 1px solid rgba(235, 235, 235, 1);
    padding-bottom: 16px;
    .label,
    .value {
      color: #000;
    }
  }
}
.error-box {
  text-align: center;
  line-height: 200px;
  font-size: 16px;
}
</style>
